import { Controller } from "stimulus";
import { csrfToken } from "@rails/ujs";
import Dropzone from "dropzone";

export default class extends Controller {
  static targets = ["toggle", "status", "backupCodes", "otpField", "submitButton", "countdown", "lockTimer","tab", "content","toggletrainingform","traingform","modalityform","togglemodalityform","togglestudyspecficform","studyspecficform","trainingicon","list"];

  connect() {
     const lastTab = sessionStorage.getItem("activeTab")
  if (lastTab) {
    // Simulate click on the saved tab
    const savedTabButton = this.tabTargets.find(tab => tab.dataset.tab === lastTab)
    if (savedTabButton) savedTabButton.click()
  }
    if (this.hasToggleTarget) {
    this.updateStatus(); 
    this.toggleTarget.addEventListener("change", () => this.handleToggleChange());
  }
  if (this.hasCountdownTarget) {
    this.startCountdown(); // Start the countdown timer
  }
}

calculateExpiryDate(event) {
  // Try both naming patterns (create form and edit form)
  const trainingTypeSelect = this.element.querySelector('[name="training_type"]') || 
                              this.element.querySelector('[name="training[training_type]"]') ||
                              this.element.querySelector('select[id*="training_type"]');
  const issueDateInput = this.element.querySelector('[name="issue_date"]') || 
                         this.element.querySelector('[name="training[issue_date]"]') ||
                         this.element.querySelector('input[id*="issue_date"]');
  const expiryDateInput = this.element.querySelector('[name="expiry_date"]') || 
                          this.element.querySelector('[name="training[expiry_date]"]') ||
                          this.element.querySelector('input[id*="expiry_date"]');

  if (!trainingTypeSelect || !issueDateInput || !expiryDateInput) {
    return;
  }

  const trainingType = trainingTypeSelect.value;
  const issueDate = issueDateInput.value;

  // Clear expiry date if training type is not selected
  if (!trainingType || trainingType === '') {
    this.setExpiryDateValue(expiryDateInput, '');
    return;
  }

  // If both fields have values, calculate expiry date
  if (trainingType && issueDate) {
    // Define validity periods in years
    const validityPeriods = {
      'GCP': 3,
      'Biosketch': 2,
      'GDPR / Data Protection': 1,
      'HIPAA': 1,
      'HIPAA Compliance': 1,
      'Common Threats / Security Awareness': 1
    };

    const yearsToAdd = validityPeriods[trainingType];

    if (yearsToAdd !== undefined) {
      // Parse the issue date
      const issueDateObj = new Date(issueDate);
      
      // Add the validity period
      const expiryDateObj = new Date(issueDateObj);
      expiryDateObj.setFullYear(expiryDateObj.getFullYear() + yearsToAdd);

      // Format the date as YYYY-MM-DD for date input
      const formattedExpiryDate = expiryDateObj.toISOString().split('T')[0];

      // Set the expiry date using helper method
      this.setExpiryDateValue(expiryDateInput, formattedExpiryDate);
    }
  }
}

setExpiryDateValue(inputElement, value) {
  // Remove readonly attribute
  inputElement.removeAttribute('readonly');
  
  // Force clear the field first
  inputElement.value = '';
  
  // Use a small timeout to ensure the browser processes the clear
  setTimeout(() => {
    inputElement.value = value;
    // Restore readonly
    inputElement.setAttribute('readonly', 'readonly');
  }, 0);
}

saveTraining(event) {
  event.preventDefault()
  const button = event.target
  
  // Check if there are files still uploading in the dropzone
  const dropzoneElement = this.element.querySelector('.dropzone')
  if (dropzoneElement) {
    try {
      const dropzone = Dropzone.forElement(dropzoneElement)
      if (dropzone && dropzone.files && dropzone.files.length > 0) {
        const uploadingFiles = dropzone.files.filter(file => 
          file.status === Dropzone.UPLOADING || 
          (file.status === Dropzone.QUEUED) ||
          file.status === "uploading" ||
          file.status === "queued"
        )
        
        if (uploadingFiles.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Upload in Progress",
            text: "Please wait for all files to finish uploading before saving."
          })
          return
        }
      }
    } catch (e) {
      // Dropzone might not be initialized yet, which is okay
      console.log("Dropzone not initialized:", e)
    }
  }
  
  const trainingType = this.element.querySelector('[name="training_type"]').value.trim()
  const issueDate = this.element.querySelector('[name="issue_date"]').value.trim()
  const expiryDate = this.element.querySelector('[name="expiry_date"]').value.trim()
  const license = this.element.querySelector('[name="license"]').value.trim()
  const description = this.element.querySelector('[name="description"]').value.trim()

  // collect signed blob IDs (Active Storage auto adds these hidden inputs)
 const imageInputs = this.element.querySelectorAll('input[name="images"][type="hidden"]')
  const imageSignedIds = Array.from(imageInputs).map(input => input.value)

  // Check which fields are missing and build error message
  const missingFields = []
  if (!trainingType) missingFields.push("Training Type")
  if (!issueDate) missingFields.push("Issue Date")
  if (!expiryDate) missingFields.push("Expiry Date")
  if (!license) missingFields.push("License")
  if (!description) missingFields.push("Description")
  if (imageSignedIds.length === 0) missingFields.push("Certificate")

  if (missingFields.length > 0) {
    const errorText = missingFields.length === 1 
      ? `${missingFields[0]} is required.`
      : `${missingFields.join(", ")} are required.`
    
    Swal.fire({
      icon: "warning",
      title: "Required!",
      text: errorText
    })
    return
  }

  button.disabled = true
  button.value = "Saving..."

  const body = {
    training_type: trainingType,
    issue_date: issueDate,
    expiry_date: expiryDate,
    license: license,
    description: description,
    images: imageSignedIds // 🔹 include blob IDs
  }

  const targetUserId = this.element.querySelector('[name="user_id"]')?.value
  if (targetUserId) {
    body.user_id = targetUserId
  }
  const studyId = this.element.querySelector('[name="study_id"]')?.value
  if (studyId) {
    body.study_id = studyId
  }

  fetch("/user_training", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
    },
    body: JSON.stringify(body)
  })
    .then(response => {
      return response.json().then(data => {
        if (!response.ok) {
          throw { data, status: response.status }
        }
        return data
      })
    })
    .then(data => {
      console.log("Training saved ✅", data)
      Swal.fire({
        icon: "success",
        title: "Uploaded!",
        text: "Training uploaded successfully."
      }).then(() => location.reload())
    })
    .catch(error => {
      console.error("Error saving training ❌", error)
      const errorMessage = error.data?.errors ? 
        (Array.isArray(error.data.errors) ? error.data.errors.join(", ") : error.data.errors) :
        "Something went wrong while saving."
      
      Swal.fire({
        icon: "error",
        title: "Saving Failed",
        text: errorMessage
      })
    })
    .finally(() => {
      button.disabled = false
      button.value = "Save"
    })
}

upload(event) {
  event.preventDefault()
  const button = event.target // this will be your <input type="submit">
  const description = this.element.querySelector('[name="description"]').value.trim()
  const certificate = this.element.querySelector('[name="certificate"]').files[0]

  // --- 1. Validations ---
  if (!description || !certificate) {
     Swal.fire({
      icon: "warning",
      title: "Required!",
      text: "Description and Certificate are required."
    })
    return
  }

  // --- 2. Disable save button to prevent duplicates ---
  button.disabled = true
  button.value = "Uploading..."  // use value for input[type=submit]

  // Use FormData for file upload
  const formData = new FormData()
  formData.append("description", description)
  formData.append("certificate", certificate)

  fetch("/user_training_attachment", {
    method: "POST",
    headers: {
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      // don't set Content-Type manually
    },
    body: formData
  })
    .then(response => {
      if (!response.ok) throw new Error("Network response was not ok")
      return response.json()
    })
    .then(data => {
      console.log("Attachment saved ✅", data)

      // --- 3. Clear fields after success ---
      this.element.querySelector('[name="description"]').value = ""
      this.element.querySelector('[name="certificate"]').value = ""

       Swal.fire({
        icon: "success",
        title: "Uploaded!",
        text: "Attachment uploaded successfully."
      }).then(() => {
  location.reload()
})
    })
    .catch(error => {
      console.error("Error saving attachment ❌", error)
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Something went wrong while uploading."
      }).then(() => {
  location.reload()
})
    })
    .finally(() => {
      button.disabled = false
      button.value = "Upload" // reset back
    })
}

  toggletrainingform() {
    this.traingformTarget.classList.toggle("hidden")

    // Update button text if you want
    if (this.traingformTarget.classList.contains("hidden")) {
      this.toggletrainingformTarget.textContent = "Add"
    } else {
      this.toggletrainingformTarget.textContent = "Add"
    }
  }

  hide() {
    this.traingformTarget.classList.add("hidden")
    this.toggletrainingformTarget.textContent = "Add"
  }

  togglestudyspecficform() {
  this.studyspecficformTarget.classList.toggle("hidden")

  if (this.studyspecficformTarget.classList.contains("hidden")) {
    this.togglestudyspecficformTarget.textContent = "Add"
  } else {
    this.togglestudyspecficformTarget.textContent = "Add"
  }
}

hidestudyspecfic() {
  this.studyspecficformTarget.classList.add("hidden")
  this.togglestudyspecficformTarget.textContent = "Add"
}

  togglemodalityform() {
  this.modalityformTarget.classList.toggle("hidden")

  if (this.modalityformTarget.classList.contains("hidden")) {
    this.togglemodalityformTarget.textContent = "Add"
  } else {
    this.togglemodalityformTarget.textContent = "Add"
  }
}

hidemodality() {
  this.modalityformTarget.classList.add("hidden")
  this.togglemodalityformTarget.textContent = "Add"
}

switch(event) {
  const selectedTab = event.currentTarget.dataset.tab
  // --- Save active tab in sessionStorage ---
  sessionStorage.setItem("activeTab", selectedTab)

  this.tabTargets.forEach(tab => {
    if (tab.dataset.tab === selectedTab) {
      tab.classList.add("border-blue-500", "bg-primary-500", "rounded-tr-lg",
                        "transition-colors", "duration-300", "ease-in-out", "text-white")
      tab.classList.remove("border-transparent")
    } else {
      tab.classList.remove("border-blue-500", "bg-primary-500", "rounded-tr-lg", "text-white")
      tab.classList.add("border-transparent")
    }
  })

  this.contentTargets.forEach(content => {
    content.classList.toggle("hidden", content.dataset.tab !== selectedTab)
  })
}

  updateStatus() {
    const status = this.toggleTarget.checked ? "Enabled" : "Disabled";
    if (this.statusTarget) {
      this.statusTarget.textContent = status;
    } else {
      console.error("Status target not found");
    }
  }

  handleToggleChange() {
    const url = `/user/${this.data.get("userId")}/update_two_factor_auth`;
    const isTwoFactorEnabled = this.toggleTarget.checked;
    const data = {
      otp_required_for_login: isTwoFactorEnabled.toString() // Convert boolean to string for params
    };
  
    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken()
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          console.log("Two-factor authentication status updated");
          this.updateStatus();
          
          // Set the message based on whether 2FA is enabled or disabled
          const message = isTwoFactorEnabled ? '2FA Successfully Enabled' : '2FA Successfully Disabled';
          
          Swal.fire({
            icon: 'success',
            title: message,
            showConfirmButton: false,
            timer: 1000
          });
          location.reload();
        } else {
          console.error("Error updating status:", data.errors);
        }
      })
      .catch(error => console.error("Error:", error));
  }
  

  copyToClipboard(event) {
    event.preventDefault(); 
  
    if (!this.hasBackupCodesTarget) {
      console.error("Backup codes target not found");
      return;
    }
  
    const backupCodes = this.backupCodesTarget.innerText;
    navigator.clipboard.writeText(backupCodes).then(() => {
      // Show a message indicating success
      const successMessage = document.createElement('div');
      successMessage.textContent = 'Backup codes copied!';
      successMessage.classList.add('text-green-600', 'mt-2');
      this.element.appendChild(successMessage);
  
      setTimeout(() => {
        successMessage.remove();
      }, 3000);
      
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }
  startCountdown() {
    const countdownElement = this.countdownTarget;
    let timeRemaining = parseInt(countdownElement.innerText);
  
    const interval = setInterval(() => {
      if (timeRemaining > 0) {
        timeRemaining -= 1;
        countdownElement.innerText = timeRemaining;
      } else {
        const parentElement = countdownElement.parentElement;
        parentElement.innerText = "You can try now.";
        parentElement.classList.remove("text-red-500");  
        parentElement.classList.add("text-green-500");   
  
        clearInterval(interval);
        this.otpFieldTarget.disabled = false;
        this.submitButtonTarget.disabled = false;
      }
    }, 1000);
  }

  validateEditTraining(event) {
    event.preventDefault();
    
    const form = event.target.closest('form');
    const trainingType = form.querySelector('[name="user_training[training_type]"]')?.value.trim() || 
                         form.querySelector('[name="training_type"]')?.value.trim();
    const issueDate = form.querySelector('[name="user_training[issue_date]"]')?.value.trim() || 
                      form.querySelector('[name="issue_date"]')?.value.trim();
    const expiryDate = form.querySelector('[name="user_training[expiry_date]"]')?.value.trim() || 
                       form.querySelector('[name="expiry_date"]')?.value.trim();
    const license = form.querySelector('[name="user_training[license]"]')?.value.trim() || 
                    form.querySelector('[name="license"]')?.value.trim();
    const description = form.querySelector('[name="user_training[description]"]')?.value.trim() || 
                        form.querySelector('[name="description"]')?.value.trim();
    
    // Check for existing images (files that haven't been deleted - look for file links in the attached files section)
    // Look for the attached files section by finding elements with "Attached Files" label or space-y-2 class
    const attachedFilesLabels = Array.from(form.querySelectorAll('label')).filter(label => 
      label.textContent.includes('Attached Files') || label.textContent.includes('attached')
    );
    let hasExistingFiles = false;
    if (attachedFilesLabels.length > 0) {
      // Find the parent form-group and check for file links
      attachedFilesLabels.forEach(label => {
        const formGroup = label.closest('.form-group');
        if (formGroup) {
          const fileLinks = formGroup.querySelectorAll('a[href*="rails/active_storage"], a[target="_blank"]');
          if (fileLinks.length > 0) {
            hasExistingFiles = true;
          }
        }
      });
    }
    
    // Check for new uploaded files (signed blob IDs from Active Storage)
    const imageInputs = form.querySelectorAll('input[name="images[]"][type="hidden"]');
    const imageSignedIds = Array.from(imageInputs).map(input => input.value).filter(id => id);
    
    // Check for file inputs with actual files
    const fileInputs = form.querySelectorAll('input[type="file"][name*="images"]');
    let hasNewFiles = false;
    fileInputs.forEach(input => {
      if (input.files && input.files.length > 0) {
        hasNewFiles = true;
      }
    });
    
    const hasCertificate = hasExistingFiles || imageSignedIds.length > 0 || hasNewFiles;
    
    // Check which fields are missing
    const missingFields = [];
    if (!trainingType) missingFields.push("Training Type");
    if (!issueDate) missingFields.push("Issue Date");
    if (!expiryDate) missingFields.push("Expiry Date");
    if (!license) missingFields.push("License");
    if (!description) missingFields.push("Description");
    if (!hasCertificate) missingFields.push("Certificate");
    
    if (missingFields.length > 0) {
      const errorText = missingFields.length === 1 
        ? `${missingFields[0]} is required.`
        : `${missingFields.join(", ")} are required.`;
      
      Swal.fire({
        icon: "warning",
        title: "Required!",
        text: errorText
      });
      return;
    }
    
    // If validation passes, submit the form
    form.submit();
  }

}
